module.exports = __webpack_public_path__ + "img/intro_1.535d2b3.png";